// src/components/NetBillPrivacyPolicy.jsx
import React from 'react';
import LegalDocPage from './LegalDocPage';

const NetBillPrivacyPolicy = () => <LegalDocPage docType="privacy" />;

export default NetBillPrivacyPolicy;
